module.exports = __webpack_public_path__ + "static/img/toplogo.b8c9fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toplogo.png
// module id = ijjk
// module chunks = 0